// extracted by mini-css-extract-plugin
export var aniSpin = "TextAccordion-module--ani-spin--xfWH7";
export var body = "TextAccordion-module--body--7Upvy";
export var container = "TextAccordion-module--container--CnRdR";
export var heading = "TextAccordion-module--heading--Ir4QH";
export var items = "TextAccordion-module--items--jJkqb";
export var main = "TextAccordion-module--main--RwnTA";
export var side = "TextAccordion-module--side--3StTN";